/* Unbroken Vine — product gallery.

   Ported from the 21energy theme's global.js sliderInit(): a Swiper for the
   main image, linked to a thumbnail Swiper — the mobile strip below 990px, the
   desktop column above it — with the .swiper-btn arrows as navigation and an
   active-thumb class kept in step on slide change.

   Scoped to .product__media-wrapper rather than that theme's .product-section,
   which does not exist here. */
(function () {
  'use strict';

  var BREAKPOINT = 990;
  var instances = [];

  function thumbEl(wrapper) {
    return window.innerWidth < BREAKPOINT
      ? wrapper.querySelector('.product__media-list-preview-wrapper--mobile .js-media-sublist')
      : wrapper.querySelector('.js-media-sublist-desktop') ||
        wrapper.querySelector('.js-media-sublist');
  }

  function syncThumbs(wrapper, activeIndex) {
    var container = thumbEl(wrapper);
    if (!container) return;
    var thumbs = container.querySelectorAll('.product__media-subitem');
    thumbs.forEach(function (thumb, i) {
      thumb.classList.toggle('product__media-subitem--active', i === activeIndex);
    });
  }

  function build(wrapper) {
    var main = wrapper.querySelector('.js-media-list');
    if (!main || typeof Swiper === 'undefined') return;

    var container = thumbEl(wrapper);
    var thumbSwiper = null;

    if (container) {
      thumbSwiper = new Swiper(container, {
        slidesPerView: 'auto',
        spaceBetween: 10,
        watchSlidesProgress: true,
        direction: window.innerWidth < BREAKPOINT ? 'horizontal' : 'vertical',
        freeMode: true
      });
    }

    var slider = new Swiper(main, {
      slidesPerView: 1,
      /* integer widths: without this a subpixel white seam shows between
         slides mid-swipe. Carried over from the source theme. */
      roundLengths: true,
      navigation: {
        nextEl: wrapper.querySelector('.swiper-btn--next'),
        prevEl: wrapper.querySelector('.swiper-btn--prev')
      },
      thumbs: { swiper: thumbSwiper },
      on: {
        slideChangeTransitionStart: function () {
          syncThumbs(wrapper, this.activeIndex);
        }
      }
    });

    /* Clicking a thumbnail moves the main slider. Swiper's own thumbs module
       does this, but only for the slider it was given; both strips exist in
       the DOM at once here, so the other one is wired by hand. */
    wrapper.querySelectorAll('.product__media-subitem').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var group = thumb.parentElement.children;
        var i = Array.prototype.indexOf.call(group, thumb);
        if (i > -1) slider.slideTo(i);
      });
    });

    instances.push({ wrapper: wrapper, slider: slider, thumbs: thumbSwiper });
    syncThumbs(wrapper, 0);
  }

  function destroyAll() {
    instances.forEach(function (i) {
      if (i.slider && i.slider.destroy) i.slider.destroy(true, true);
      if (i.thumbs && i.thumbs.destroy) i.thumbs.destroy(true, true);
    });
    instances = [];
  }

  function init() {
    destroyAll();
    document.querySelectorAll('.product__media-wrapper').forEach(build);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* The thumbnail strip swaps orientation at the breakpoint, so the sliders
     are rebuilt when the viewport crosses it - not on every resize tick. */
  var wide = window.innerWidth >= BREAKPOINT;
  window.addEventListener('resize', function () {
    var nowWide = window.innerWidth >= BREAKPOINT;
    if (nowWide !== wide) { wide = nowWide; init(); }
  });

  document.addEventListener('shopify:section:load', init);
})();
